module.exports = "/fonts/vendor/@bcgov/bootstrap-theme/dist/bc-sans/BCSans-BoldItalic.woff?acf86adee11c6f27a4ddb1619c524d5c";